import ActionsCell from "./ActionsCell";
import { textFilter } from "helpers/tableFilters";

const columns = [
  {
    Header: "Empresa",
    accessor: "companyName",
    filterable: true,
    filterMethod: textFilter("companyName"),
  },
  {
    Header: "Número Cuenta",
    accessor: "accountingAccountNumber",
    filterable: true,
    filterMethod: textFilter("accountingAccountNumber"),
  },
  {
    Header: "Tipo de Cuenta",
    accessor: "typeLabel",
    filterable: true,
    filterMethod: textFilter("typeLabel"),
  },
  {
    Header: "Acciones",
    filterable: false,
    Cell: ActionsCell,
  },
];

export default columns;
